var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jsf-form',_vm._b({staticClass:"vjsf"},'jsf-form',_vm.finalFormProps,false),[_c('SchemaItem',{attrs:{"schema":_vm.schema,"root-schema":_vm.schema,"ui-schema":_vm.uiSchema,"on-change":_vm.handleChange,"value":_vm.form,"path":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }